import React from "react";
import { Col, Row } from "antd";
import { t } from "i18next";

import style from "./StampsForeignInfo.module.scss";
import { IZahtevZaMarkicuUvoznikProps } from "../../../../../modules/obligee/exciseStamps/exciseStamps.types";

interface IStampsUserInfoProps {
  exciseStampsInfo: IZahtevZaMarkicuUvoznikProps;
}

export const StampsForeignInfo: React.FC<IStampsUserInfoProps> = ({
  exciseStampsInfo,
}) => {
  return (
    <Col className={style.mainContainer} span={24}>
      <Col className={style.title} span={24}>
        {t(
          "AKCIZNE_MARKICE.PODACI_O_INOSTRANOM_PROIZVODJACU_ODNOSNO_DISTRIBUTERU_INOSTRANOG_PROIZVODJACA_UVOZNIK"
        )}
      </Col>
      <Row className={style.row}>
        <Col className="yCenter" span={5}>
          <span className={style.fontSize}>
            {t("AKCIZNE_MARKICE.NAZIV_INOSTRANOG_PROIZVODJACA")}:
          </span>
        </Col>
        <Col className="mr-70" span={5}>
          <span className={style.fontSize}>
            {exciseStampsInfo.inostraniProizvodjacNaziv}
          </span>
        </Col>
        <Col className="yCenter" span={7}>
          <span className={style.fontSize}>
            {t("AKCIZNE_MARKICE.NAZIV_DISTRIBUTERA_INOSTRANOG_PROIZVODJACA")}:
          </span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>
            {exciseStampsInfo.distributerInostranogProizvodjacaNaziv}
          </span>
        </Col>
      </Row>
      <Row className={style.row}>
        <Col className="yCenter" span={5}>
          <span className={style.fontSize}>
            {t("AKCIZNE_MARKICE.PORESKI_BROJ_INOSTRANOG_PROIZVODJACA")}:
          </span>
        </Col>
        <Col className="mr-70" span={5}>
          <span className={style.fontSize}>
            {exciseStampsInfo.inostraniProizvodjacPoreskiBroj}
          </span>
        </Col>
        <Col className="yCenter" span={7}>
          <span className={style.fontSize}>
            {t(
              "AKCIZNE_MARKICE.PORESKI_BROJ_DISTRIBUTERA_INOSTRANOG_PROIZVODJACA"
            )}
            :
          </span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>
            {exciseStampsInfo.distributerInostranogProizvodjacaPoreskiBroj}
          </span>
        </Col>
      </Row>
      <Row className={style.row}>
        <Col className="yCenter" span={5}>
          <span className={style.fontSize}>{t("AKCIZNE_MARKICE.ADRESA")}:</span>
        </Col>
        <Col className="mr-70" span={5}>
          <span className={style.fontSize}>
            {exciseStampsInfo.inostraniProizvodjacAdresa}
          </span>
        </Col>
        <Col className="yCenter" span={7}>
          <span className={style.fontSize}>{t("AKCIZNE_MARKICE.ADRESA")}:</span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>
            {exciseStampsInfo.distributerInostranogProizvodjacaAdresa}
          </span>
        </Col>
      </Row>
      <Row className={style.row}>
        <Col className="yCenter" span={5}>
          <span className={style.fontSize}>{t("AKCIZNE_MARKICE.MESTO")}:</span>
        </Col>
        <Col className="mr-70" span={5}>
          <span className={style.fontSize}>
            {exciseStampsInfo.inostraniProizvodjacMesto}
          </span>
        </Col>
        <Col className="yCenter" span={7}>
          <span className={style.fontSize}>{t("AKCIZNE_MARKICE.MESTO")}:</span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>
            {exciseStampsInfo.distributeraInostranogProizvodjacaMesto}
          </span>
        </Col>
      </Row>
      <Row>
        <Col className="yCenter" span={5}>
          <span className={style.fontSize}>
            {t("AKCIZNE_MARKICE.ADRESA_SLANJA_MARKICA")}:
          </span>
        </Col>
        <Col className="mr-70 ml-12" span={5}>
          <span className={style.fontSize}>
            {
              exciseStampsInfo.distributerInostranogProizvodjacaAdresaSlanjaMarkica
            }
          </span>
        </Col>
      </Row>
    </Col>
  );
};
